import moment from 'moment'

const HELSINKI_TZ = 'Europe/Helsinki'
const VERIFIED_UNTIL_FORMAT = 'DD.MM.YYYY HH:mm'

const helsinkiDateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: HELSINKI_TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
})

const getFormatPart = (parts, type) =>
  Number(parts.find(part => part.type === type).value)

const getHelsinkiOffsetMs = utcMs => {
  const parts = helsinkiDateTimeFormatter.formatToParts(new Date(utcMs))
  let hour = getFormatPart(parts, 'hour')
  if (hour === 24) {
    hour = 0
  }

  const asUtcMs = Date.UTC(
    getFormatPart(parts, 'year'),
    getFormatPart(parts, 'month') - 1,
    getFormatPart(parts, 'day'),
    hour,
    getFormatPart(parts, 'minute'),
    getFormatPart(parts, 'second')
  )

  return asUtcMs - utcMs
}

// Backend sends verifiedUntil as a Helsinki wall-clock string with no offset.
// moment() would otherwise treat it as the browser's local timezone.
export const parseHelsinkiDateTime = dateTimeString => {
  const wallClock = moment(dateTimeString, VERIFIED_UNTIL_FORMAT, true)
  if (!wallClock.isValid()) {
    return wallClock
  }

  const utcGuess = Date.UTC(
    wallClock.year(),
    wallClock.month(),
    wallClock.date(),
    wallClock.hour(),
    wallClock.minute()
  )
  const offset = getHelsinkiOffsetMs(utcGuess)
  let utcMs = utcGuess - offset
  const adjustedOffset = getHelsinkiOffsetMs(utcMs)
  if (adjustedOffset !== offset) {
    utcMs = utcGuess - adjustedOffset
  }

  return moment(utcMs)
}

export const sanitizeTicketCode = ticketCode => String(ticketCode || '').trim()

export const isTicketVerificationValid = ticket => {
  if (!ticket?.verification?.available) {
    return true
  }

  if (!ticket.verified) {
    return false
  }

  if (!ticket.verifiedUntil) {
    return true
  }

  return parseHelsinkiDateTime(ticket.verifiedUntil).isAfter(moment())
}
